import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";

import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import {
  capaPriorities,
  FORM_LABEL_OFFICER,
  initialCapa,
} from "../IncidentManagement/CONSTANTS";
import { getCapaById } from "app/_services/ehs/ehsCapaServices";
import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import LogHistory from "app/views/custom/components/Logs/LogHistory";
import CompletionProof from "./CompletionProof";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import { getVFLByID } from "app/_services/ehs/VFLService";
import IncidentTimeline from "../IncidentManagement/IncidentTimeline";
import VFLTimeline from "../VFL/component/VFLTimeline";
import ViewCommentsComponent from "../IncidentManagement/ViewCommentsComponent";
import { Link } from "react-router-dom";
import { VFL_STATUS } from "../VFL/CONSTANTS";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import toastr from "toastr";
const ViewCAPA = ({
  match: {
    params: { id, siteId },
  },
  history,
}) => {
  const [tab, setTab] = useState(1);
  const [form, setForm] = useState({ ...initialCapa });
  const [incidentVflDetails, setIncidentVflDetails] = useState({});
  const [capaComments, setCapaComments] = useState([]);
  const [subArea, setSubArea] = useState([]);

  useEffect(() => {
    getCapaById(id).then((response) => {
      if (!response?.status) {
        history.push("/health-safety-and-environment/capa-management");
        toastr.error(response?.message || "Something went Wrong");
        return;
      }
      if (!response?.data) return;
      setForm(response.data);

      if (response?.data?.source === "Incident Management") {
        getIncidentReportById(response?.data?.incidentDetailsId, "role=reviewer").then(
          (details) => {
            if (!details?.data) return;

            setIncidentVflDetails((prev) => {
              return {
                ...details.data,
                rootCauseAnalysisRequired: details.data.investigationDetails
                  ?.rootCauseAnalysisRequired
                  ? true
                  : false,
              };
            });

            setCapaComments(
              details?.data?.capas?.find((obj) => obj.id === response?.data?.id)
                ?.ehs_capa_reviews
            );
          }
        );
      } else {
        getVFLByID(response?.data?.incidentDetailsData?.vflId).then((details) => {
          if (!details?.data) return;

          setIncidentVflDetails({
            ...details.data,
          });

          setCapaComments(
            details?.data?.vflObservations
              ?.find((o) => o.allCapa?.find((k) => k.id === response?.data?.id))
              ?.allCapa.find((p) => p.id === response?.data?.id)?.ehs_capa_reviews
          );
        });
      }
    });
  }, [id]);

  useEffect(() => {
    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      const subAreaObj = response.data.find((d) => d.id === form?.workArea?.id);
      setSubArea(subAreaObj?.subAreaOfOperation || []);
    });
  }, [form?.workArea?.id]);

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "CAPA Management",
            path: "/health-safety-and-environment/capa-management",
          },
          {
            name: "Manage CAPA",
            path: "/health-safety-and-environment/capa-management/manage-capa",
          },
          {
            name: "View",
          },
        ]}
      />
      {/* <Breadcrumb
                routeSegments={[
                    { name: "Health Safety And Environment" },
                    { name: "Manage CAPA", path: (siteId ? `/sites/${siteId}` : "") + "/health-safety-and-environment/capa-management/manage-capa" },
                    { name: "View" },
                ]}
            /> */}

      {/* <div className="simple-card-title">
                    <h3 class="text-capitalize mb-0">View CAPA</h3>
                    <BackBtn />
                </div> */}
      <div className="healthSafetyEnvironmentWrapper lrgTabberWrapper mb-3">
        <div className="hseMenuLinks card">
          <a
            href
            onClick={() => setTab(1)}
            className={`pointer${tab === 1 ? " active" : ""}`}
          >
            Timeline
          </a>
          <a
            href
            onClick={() => setTab(2)}
            className={`pointer${tab === 2 ? " active" : ""}`}
          >
            CAPA Details
          </a>
          {capaComments?.length ? (
            <a
              href
              onClick={() => setTab(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              Workflow Inputs
            </a>
          ) : (
            ""
          )}
        </div>
      </div>
      {/* <Row> */}
      {tab === 1 && (
        <Col lg={12}>
          {form?.source === "Incident Management" ? (
            <IncidentTimeline
              reportDate={incidentVflDetails.reportDate}
              reporter={incidentVflDetails.reporter}
              investigationCompletionDate={incidentVflDetails.investigationCompletionDate}
              reviewCompletionDate={incidentVflDetails.reviewCompletionDate}
              investigationDetails={incidentVflDetails?.investigationDetails}
              reviewer={incidentVflDetails.reviewer}
              closer={incidentVflDetails.closer}
              personalDetails={incidentVflDetails.personalDetails}
              vehicleDetails={incidentVflDetails.vehicleDetails}
              assetDetails={incidentVflDetails.assetDetails}
              spills={incidentVflDetails.spills}
              //evidences={evidences}
              investigationCompleted={incidentVflDetails.investigationCompleted}
              reviewCompleted={incidentVflDetails.reviewCompleted}
              closureCompleted={incidentVflDetails.closureCompleted}
              isAssetIncident={incidentVflDetails.isAssetIncident}
              isPersonalInjury={incidentVflDetails.isPersonalInjury}
              isSpillsIncident={incidentVflDetails.isSpillsIncident}
              isVehicleIncident={incidentVflDetails.isVehicleIncident}
              closureCompletionDate={incidentVflDetails.closureCompletionDate}
              incidentStatus={incidentVflDetails.incidentStatus}
              insuranceApplicable={incidentVflDetails.insuranceApplicable}
              complianceRequired={incidentVflDetails.complianceRequired}
              trainingRequired={incidentVflDetails.trainingRequired}
              witnessStatementRequired={incidentVflDetails.witnessStatementRequired}
              rootCauseAnalysisRequired={incidentVflDetails.rootCauseAnalysisRequired}
              solutionRequired={incidentVflDetails.solutionRequired}
              capaRequired={incidentVflDetails.capaRequired}
              reportEvidencesRequired={incidentVflDetails.reportEvidencesRequired}
              evidencesRequired={incidentVflDetails.evidencesRequired}
              reviewEvidencesRequired={incidentVflDetails.reviewEvidencesRequired}
              incidentId={incidentVflDetails.incidentId}
              incidentDate={incidentVflDetails.incidentDate}
              type={incidentVflDetails.type}
              severity={incidentVflDetails.severity}
              severityPostReview={incidentVflDetails.severityPostReview}
              workArea={incidentVflDetails.workArea}
              site={incidentVflDetails.site}
              department={incidentVflDetails.department}
              isCapaPresent={
                incidentVflDetails.capas ? incidentVflDetails.capas.length : 0
              }
              capaCompletionDate={incidentVflDetails?.capaCompletionDate}
              capaCompletedByData={incidentVflDetails?.capaCompletedByData}
              finalReviewedByDate={incidentVflDetails?.finalReviewedByDate}
              finalReviewedByData={incidentVflDetails?.finalReviewedByData}
              reviewedByMMDate={incidentVflDetails?.reviewedByMMDate}
              reviewedByMMData={incidentVflDetails?.reviewedByMMData}
              reviewedDate={incidentVflDetails?.reviewedDate}
              staffData={incidentVflDetails?.staffData}
              staffType={incidentVflDetails?.staffType}
              otherStaffName={incidentVflDetails?.otherStaffName}
              area={incidentVflDetails?.area}
              capasList={incidentVflDetails?.capas}
              reportAtLabel={FORM_LABEL_OFFICER[incidentVflDetails?.reportAtLabel]}
              capaTimeLine
              form={incidentVflDetails}
            />
          ) : (
            <VFLTimeline form={incidentVflDetails} capaTimeLine />
          )}
        </Col>
      )}
      {tab === 2 && (
        <>
          <div className="card p-3 mt-4">
            <div className="simple-card-title">
              <h3 class="text-capitalize mb-0">Details</h3>
            </div>
            <div className="ehsFormWrapper">
              <Row>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Location Name - Location ID</h5>
                    <p>
                      {form.site?.name} {form.site?.siteId}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Source Type</h5>
                    <p>{form.source === "ehs_vfl_observations" ? "VFL" : form.source}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">
                      {form?.source === "Incident Management" ? "Incident" : "VFL"} ID
                    </h5>
                    {form?.source === "Incident Management" ? (
                      <Link
                        to={
                          "/health-safety-and-environment/incident-management/review/view/" +
                          incidentVflDetails.id
                        }
                        target="_blank"
                        className=""
                      >
                        <p>{incidentVflDetails?.incidentId}</p>
                      </Link>
                    ) : (
                      <Link
                        to={
                          incidentVflDetails.vflStatus === VFL_STATUS.completed
                            ? "/health-safety-and-environment/vfl/completion/view/" +
                              incidentVflDetails.id
                            : "/health-safety-and-environment/vfl/view/" +
                              incidentVflDetails.id
                        }
                        target="_blank"
                        className=""
                      >
                        <p>{incidentVflDetails?.vflId}</p>
                      </Link>
                    )}
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">CAPA ID</h5>
                    <p>{form.capaId}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Source Area</h5>
                    <p>{form.workArea?.name}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Sub Area</h5>
                    <p>
                      {form?.subAreaId === 999
                        ? "Other"
                        : subArea.find((d) => d.id === form?.subAreaId)?.name}
                    </p>
                  </div>
                </Col>
                {form?.subAreaId === 999 && (
                  <Col lg={4}>
                    <div className="form-group viewbox">
                      <h5 className="w-500">Other Sub Area</h5>
                      <p>{form.otherSubArea}</p>
                    </div>
                  </Col>
                )}
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">CAPA Owner</h5>
                    <p>{userDropdownLabel(form.owner)}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Priority</h5>
                    <p>{capaPriorities[form.priority]}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Due Date</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(form.dueDate)}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Created Date</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(form.createdAt)}</p>
                  </div>
                </Col>
                <Col lg={8}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">CAPA Description</h5>
                    <p>{form.solution}</p>
                  </div>
                </Col>
                {form?.revertMessage ? (
                  <Col lg={12}>
                    <div className="form-group viewbox">
                      <h5 className="w-500 mb-1">Return Message</h5>
                      <p>{form?.revertMessage}</p>
                    </div>
                  </Col>
                ) : (
                  ""
                )}
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Completed</h5>
                    <p>{form.capaStatus === "Open" ? "No" : "Yes"}</p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500">Completion Proof</h5>
                    <p>
                      {form.completionProof && (
                        <CompletionProof file={form.completionProof} />
                      )}
                    </p>
                  </div>
                </Col>
                <Col lg={4}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">Completion Date</h5>
                    <p>{formatDDMMYYYYbyYYYYMMDD(form.completionDate)}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="form-group viewbox">
                    <h5 className="w-500 mb-1">
                      {" "}
                      Describe Actions Taken or Resolution Provided
                    </h5>
                    <p>{form.actionsOrResolutions}</p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
          <div className="pt-3">
            <LogHistory subModulename={"ehsCapa"} refrenceId={id} />
          </div>
        </>
      )}
      {tab === 3 && (
        <Col lg={12} className="pt-3">
          <ViewCommentsComponent comments={capaComments ? capaComments : []} />
        </Col>
      )}
      {/* </Row> */}

      <div className="mt-4 text-center">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </>
  );
};

export default ViewCAPA;
